module.exports = __webpack_public_path__ + "img/archive.3cb6800f.svg";